import { notification } from 'antd/lib'
import { useUserDetails } from 'Contexts/UserDetailsContext'
import { StudioConfigType } from 'Core/Studio'
import useService from 'Hooks/use-service'
import { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { getExamAssignment } from 'Services/exams.service'
import { TaskMode } from 'Types/Tasks.types'

type StudioConfigDataType = Omit<StudioConfigType, 'onNextTask' | 'onExitTask' | 'context'>

export const useExamAssignment = (answerId?: string) => {
    const userDetails = useUserDetails()
    const [examAssignmentConfig, setExamAssignmentConfig] = useState<StudioConfigDataType>()
    const navigate = useNavigate()
    const { isLoading, error, trigger } = useService(getExamAssignment)
    const [id, setId] = useState<string>()

    const fetchAssignment = useCallback(async () => {
        if (!answerId || !userDetails?.userID) return
        const assignmentData = await trigger({ answerId, userId: userDetails?.userID })
        if (assignmentData) {
            const config: StudioConfigDataType = {
                taskType: assignmentData?.assignment.task.type,
                taskConfig: {
                    assignment: assignmentData?.assignment,
                    submissionId: assignmentData?.assignment.submission?.id,
                    mode: assignmentData?.assignment.step?.type
                        ? assignmentData?.assignment.step?.type
                        : TaskMode.Maker,
                    useCase: assignmentData?.assignment.task.type,
                },
                pluginsConfig: [],
            }
            setExamAssignmentConfig(config)
            setId(assignmentData?.assignment.id)
        }
    }, [answerId, trigger, userDetails?.userID])

    useEffect(() => {
        fetchAssignment()
    }, [answerId, fetchAssignment])

    useEffect(() => {
        if (error) {
            notification.error({
                message: (error as Error).message ?? 'Error in getting question',
                description:
                    'Please try again. If you still face the issue, reach out to the project owner',
                placement: 'bottomLeft',
            })
            navigate(`/`, { replace: true })
        }
    }, [error, navigate])

    return { studioConfig: examAssignmentConfig, isLoading, error, id }
}
